module.exports = {"uuid":"","code":"","codeBody":"","codeIndex":"","codeFontSize":12,"codeFontStyle":"normal","codeFontFamily":"simsun","name":"","nameFontSize":14,"nameFontStyle":"bold","nameFontFamily":"simsun","boothType":"","entryType":"","lateralLength":0,"verticalLength":0,"area":0,"status":"normal","shapeUuid":"","stageUuid":"","tenantId":"","tenantName":"","isSpecial":"0","czlx":""}


//////////////////
// WEBPACK FOOTER
// ./src/components/ploter/businessShape/emptyData.json
// module id = Vy7+
// module chunks = 137